import type { UserMessageComponent } from 'api/types';

export function hasMetadata(
  metadata: UserMessageComponent['component_fields']['metadata'],
): metadata is Exclude<
  UserMessageComponent['component_fields']['metadata'],
  undefined
> {
  return Boolean(metadata && (metadata.title || metadata.description));
}
